import { request } from './request';

/**
 * 获取科技交流中心信息
 */
export function getTechnologyExchangeCenterInfo() {
  return request.get('/technology_exchange_center/info');
}

/**
 * 会议室信息
 */
export interface MeetingRoom {
  id: number;
  name: string;
  introduce: string;
  image: string;
  sortOrder: number;
  createBy: string;
  createTime: string;
  updateBy: string | null;
  updateTime: string;
  remark: string | null;
}

/**
 * 描述信息
 */
export interface DescInfo {
  key: string;
  description: string;
}

/**
 * 科技交流中心信息数据类型
 */
export interface TechnologyExchangeCenterInfo {
  descInfo: DescInfo;
  meetingList: MeetingRoom[];
}
